// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 11.692c0-.382.31-.692.692-.692h16.616a.692.692 0 010 1.385H3.692A.692.692 0 013 11.692z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;